import classNames from 'classnames';
import React from 'react';
import './Image.scss';
import IImageProps from './ImageProps';

const Image = ({ src, alt, width, height, responsive = true, disabled = false, onClick, className }: IImageProps) => {
  const classes = classNames(
    {
      'image': true,
      'image-responsive': responsive,
    },
    className
  );

  function handleClick(event: React.MouseEvent) {
    if (!disabled && onClick) {
      onClick(event);
    }
  }

  return <img src={src} alt={alt} width={width} height={height} onClick={handleClick} className={classes} />;
};

export default Image;
